<template>
  <b-container>

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" size="sm"/>
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col>
        <b-button
          variant="outline-success"
          size="sm"
          @click="downloadExcel"
          style="float: right; font-size: 1em; font-color: green; margin-left: 10px"
          v-if="claims.length > 0"
        >
          <i class="fa fa-file-excel"></i> Excel
        </b-button>
        <b-button
          variant="outline-info"
          size="sm"
          @click="downloadTxt"
          style="float: right; font-size: 1em; font-color: blue"
          v-if="claims.length > 0"
        >
          <i class="fa fa-file-text"></i> TXT
        </b-button>
      </b-col>
      <b-col md="4">
        <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      selectable
      select-mode="single"
      head-variant="dark"
      empty-text="No Disbursal available."
      stacked="md"
      bordered
      striped
      :items="claims"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      @row-selected="onRowSelected"
      style="font-size:12px"
    >
      <template v-slot:cell(selected)="{ rowSelected }">
      <!-- <template slot="selected" slot-scope="row"> -->
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not Selected</span>
        </template>
      </template>
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click.stop="viewDisbursal(row.item, row.index, $event.target)"
          class="mr-1 pt-0 pb-0"
          variant="success"
          v-b-tooltip.hover
          title="View Details"
        >View</b-button>

      </template>
    </b-table>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
          <b-form-select :options="pageOptions" v-model="perPage" size="sm"/>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import XLSX from "xlsx";

export default {
  components: { Spinner },
  props: ["ClaimUserID"],
  data() {
    return {
      show: false,
      showsts: false,
      modalInfo: "",
      districts: [],
      schemes: [],
      approvalStatus: [],
      claims: [],
      bscReport: "",
      bscReportPath: "",
      fields: [
      { key: "EMIPaidDate", label:"Month", formatter: "convertDateFormat"},
        { key: "UpdatedDate", label:"Claim Date", formatter: "convertDateFormat"}

        , "EMIPaidAmt","PrincipalAmt", "InterestAmt", "PenaltyCharges","ClaimStatus"],
    //     { key: "selected", label: "Selected" },
    //     { key: "EMIPaidDate", label: "Application No", sortable: true },
    //     { key: "DisbursalDate", label: "Disbursal Date", sortable: true },
    //     { key: "DisburmentAmount", label: "Disbursed Amount", sortable: true },
    //     { key: "EmiAmount", label: "EMI", sortable: true },
    //     { key: "EmiStartDate", label: "Emi Start Date", sortable: true },
    //     { key: "EmiEndDate", label: "EMI End Date"},
    //     { key: "LoanTenure", label: "Tenure Months" },
    //     { key: "Status", label: "Status", sortable: true },
    //     { key: "action", label: "View" }
    //   ],
      selected: [],
      form: {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: ""
      },
      selectedApplication: "",
      currentPage: 1,
      perPage: 60,
      totalRows: 0,
      pageOptions: [60,100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    Add() {
      this.$router.push("/claimupload");
    },
    viewDisbursal(item, index, target){
      alert(JSON.stringify(item));
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getApprovalStatus() {
      let promise = apis.getApplicationStatusMstr();
      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.approvalStatus = response.body;
            this.form.ApplicationStatusID = this.$store.getters.getAppStatus;
          } else {
            this.alertText =
              "Unable to Load Approval Status List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.getApplicationsSub();
    },

    getSanctionLetterDetails() {
      let userid = this.ClaimUserID;

      let promise = apis.ReadSanctionLetterByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.LoanDetails = response.body;
            this.$store.dispatch('setSanctionLetter', this.LoanDetails);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    getDisbursals() {
      this.isLoading = true;
      this.showDismissibleAlert = false;
      let userid = this.ClaimUserID;

      let promise = apis.readClaims(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.claims = response.body;
            this.totalRows = this.claims.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: ""
      };
    },

    downloadExcel() {
      if (this.claims.length === 0) {
        this.$dialog.alert("No claims data to export");
        return;
      }

      var columns = [
        "Claim Date",
        "EMI Paid Date",
        "EMI Paid Amount",
        "Principal Amount",
        "Interest Amount",
        "Penalty Charges",
        "Claim Status"
      ];

      let app_data = [];
      this.claims.forEach((element) => {
        let obj = {
          "Claim Date": this.convertDateFormat(element.UpdatedDate),
          "EMI Paid Date": this.convertDateFormat(element.EMIPaidDate),
          "EMI Paid Amount": element.EMIPaidAmt,
          "Principal Amount": element.PrincipalAmt,
          "Interest Amount": element.InterestAmt,
          "Penalty Charges": element.PenaltyCharges,
          "Claim Status": element.ClaimStatus
        };
        app_data.push(obj);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(app_data, { header: columns });

      ws["!cols"] = [
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 100 }
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Claims_Admin");
      XLSX.writeFile(wb, "Claims_Admin_List.xlsx");
    },

    downloadTxt() {
      if (this.claims.length === 0) {
        this.$dialog.alert("No claims data to export");
        return;
      }

      var columns = [
        "Claim Date",
        "EMI Paid Date",
        "EMI Paid Amount",
        "Principal Amount",
        "Interest Amount",
        "Penalty Charges",
        "Claim Status"
      ];

      let app_data = [];
      this.claims.forEach((element) => {
        let obj = {
          "Claim Date": this.convertDateFormat(element.UpdatedDate),
          "EMI Paid Date": this.convertDateFormat(element.EMIPaidDate),
          "EMI Paid Amount": element.EMIPaidAmt,
          "Principal Amount": element.PrincipalAmt,
          "Interest Amount": element.InterestAmt,
          "Penalty Charges": element.PenaltyCharges,
          "Claim Status": element.ClaimStatus
        };
        app_data.push(obj);
      });

      // Create TXT content with fixed-width formatting
      let txtContent = "";

      // Add header
      txtContent += "वीवर समुदाय आर्थिक विकास महामंडळ\n";
      txtContent += "CLAIMS ADMIN LIST REPORT\n";
      txtContent += "Generated Date: " + new Date().toDateString() + "\n\n";

      // Create properly aligned columns using fixed positioning
      const header = "Claim Date   EMI Paid Date  EMI Paid Amount  Principal Amount Interest Amount  Penalty Charges Claim Status   ";
      const separator = "=".repeat(header.length);

      txtContent += header + "\n";
      txtContent += separator + "\n";

      // Add data rows with fixed positioning
      app_data.forEach((row) => {
        const line =
          String(row["Claim Date"] || "").padEnd(13) +
          String(row["EMI Paid Date"] || "").padEnd(15) +
          String(row["EMI Paid Amount"] || "").padEnd(17) +
          String(row["Principal Amount"] || "").padEnd(17) +
          String(row["Interest Amount"] || "").padEnd(16) +
          String(row["Penalty Charges"] || "").padEnd(16) +
          String(row["Claim Status"] || "");

        txtContent += line.trim() + "\n";
      });

      // Create and download the file
      const blob = new Blob([txtContent], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Claims_Admin_List.txt";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    }
  },
  mounted() {
  console.log(this.ClaimUserID);
    this.getDisbursals();
    this.getSanctionLetterDetails();
   this.getApprovalStatus();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimUpload/ClaimListAdmin.vue